<template>
  <v-dialog v-model="dialog" :max-width="loading ? '400px' : '70%'">
    <v-card v-if="loading">
      <v-card-text class="text-center pa-5">
        <v-progress-circular
          class="mr-2"
          size="24"
          width="3"
          indeterminate
          color="primary"
        ></v-progress-circular>
        Buscando informações
      </v-card-text>
    </v-card>
    <v-card v-else-if="openedChat">
      <v-card-title>
        <div class="row align-center pa-0">
          <div class="col headline">
            {{ chatID }} <v-chip class="ml-2" label :color="statusColor[openedChat.situation] || 'grey-3'">{{ statusInfo[openedChat.situation] || openedChat.situation }}</v-chip></span>
          </div>
          <div class="col-auto pa-sm">
            <v-btn fab text color="default" @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-divider />
      <div class="row ma-4">
        <v-col cols="6" sm="4" md="3">
          <small>Agente</small>
          <br>
          <b>{{ openedChat.agents && openedChat.agents.map(a => a.name).join(', ') }}</b>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <small>Departamento</small>
          <br>
          <b>{{ (openedChat.chatDepartment && openedChat.chatDepartment.name) || '-' }}</b>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <small>Classificação</small>
          <br>
          <b>{{ (openedChat.chatTabulation && openedChat.chatTabulation.name) || '-' }}</b>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <small>Canal</small>
          <br>
          <b>{{ (openedChat.channels && openedChat.channels[0] && openedChat.channels[0].type) || '-' }}</b>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <small>Criado em</small>
          <br>
          <b>{{ openedChat.createdAt | moment('DD/MM/YYYY hh:mm') }}</b>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <small>Conversa iniciada em</small>
          <br>
          <b>{{ openedChat.attendedAt | moment('DD/MM/YYYY hh:mm') }}</b>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <small>Finalizado em</small>
          <br>
          <b>{{ openedChat.closedAt | moment('DD/MM/YYYY hh:mm') }}</b>
        </v-col>
        <v-col cols="6" sm="4" md="3">
          <small>Tempo de conversa</small>
          <br>
          <b>{{ duration }}</b>
        </v-col>
      </div>
      <div class="row mx-4 mt-2 pb-5">
        <div class="col-12" v-for="message in messages" :key="message.id">
          <v-alert v-if="message.isInternal" dense color="grey lighten-2" class="mb-0">
            <div class="mb-1 text-bold text-caption">
              <b>Mensagem Interna:</b>
              {{ message.sender.name }} <template v-if="message.senderType === 'virtual_agent'">(Agente virtual)</template>
              {{ message.sendAt | moment('DD/MM/YYYY hh:mm') }}
            </div>
            <div style="white-space: pre-line" v-html="ajustText(message.text)"></div>
          </v-alert>
          <v-alert v-else dense class="mb-0" :class="['agent', 'virtual_agent'].includes(message.senderType) ? 'ml-15 deep-purple lighten-5' : 'mr-15 grey lighten-4'">
            <div class="mb-1 text-bold text-caption">
              <b>{{ message.sender.name }} <template v-if="message.senderType === 'virtual_agent'">(Agente virtual)</template></b>
              {{ message.sendAt | moment('DD/MM/YYYY hh:mm') }}
            </div>
            <div v-if="message.type === 'audio'">
              <audio controls>
                <source :src="message.file" type="audio/ogg">
                Áudio não suportado, tente acessar por:
                <br />
                <a :href="message.file" target="_blank">{{ message.file }}</a>
              </audio>
            </div>
            <div v-else-if="message.type === 'image'">
              <a :href="message.file" target="_blank">
                <img :src="message.file" style="max-width: 100%; max-height: 80px;" />
              </a>
            </div>
            <div v-else-if="message.file">
              <a :href="message.file" target="_blank">{{ message.file }}</a>
            </div>
            <div v-else style="white-space: pre-line" v-html="ajustText(message.text)"></div>
          </v-alert>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

export default {
  name: 'huggyDetailsDialog',
  props: ['openedChat'],
  data () {
    return {
      dialog: false,
      loading: false,
      // tab: 'tab-comments',
      messages: []
    }
  },
  computed: {
    chatID () {
      return this.openedChat && this.openedChat.id
    },
    statusInfo () {
      return {
        auto: 'Agente Virtual',
        in_chat: 'Em atendimento',
        wait_for_chat: 'Na fila',
        blocked: 'Bloqueado',
        finishing: 'Encerrado',
        finished: 'Encerrado',
        filed: 'Arquivado'
      }
    },
    statusColor () {
      return {
        auto: 'primary',
        in_chat: 'primary',
        wait_for_chat: 'secondary',
        blocked: 'error',
        finishing: 'success',
        finished: 'success',
        filed: 'grey-3'
      }
    },
    duration () {
      const date1 = this.$moment(this.openedChat.attendedAt)
      const date2 = this.$moment(this.openedChat.closedAt || new Date())
      let seconds = date2.diff(date1, 'seconds')
      let minutes = 0
      if (seconds > 60) {
        minutes = Math.floor(seconds / 60)
        seconds = seconds % 60
      }
      let hours = 0
      if (minutes > 60) {
        hours = Math.floor(minutes / 60)
        minutes = minutes % 60
      }
      let days = 0
      if (hours > 24) {
        days = Math.floor(hours / 24)
        hours = hours % 24
      }
      let message = ''
      if (days) message += days + ' dias, '
      if (hours) message += hours + ' horas, '
      if (minutes) message += minutes + ' minutos, '
      if (seconds) message += seconds + ' segundos, '
      return message.substring(0, message.length - 2)
    }
  },
  watch: {
    openedChat (val) {
      if (val) {
        this.dialog = true
        this.getChatInfo()
      }
    },
    dialog (val) {
      if (!val) {
        this.$emit('close')
        this.$emit('updateList')
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    ...mapActions(['copyToClipboard']),
    async getChatInfo () {
      this.loading = true
      try {
        const response = await this.$store.dispatch('huggyApi', { method: 'GET', url: 'chats/' + this.chatID + '/messages' })
        console.log(response)
        this.messages = (response && response.reverse()) || []
      } catch (error) {
        console.log('error', error)
        this.messages = []
      }
      this.loading = false
    },
    donwloadBlob (fileURL) {
      this.donwloadingFile = fileURL
      this.$store.dispatch('clubhouseApi', { method: 'GET', url: fileURL, isBlob: true })
        .then((response) => {
          console.log(response)
        }).catch((e) => {
          this.SET_SNACKBAR({ text: 'Não foi possivel fazer o download do arquivo, tente novamente' })
          this.donwloadingFile = false
        })
    },
    ajustText (text) {
      let ajustedText = text || ''
      if (ajustedText) {
        // Image
        const imageRegex = /(!\[.*\))/g
        ajustedText = ajustedText.replace(imageRegex, (file) => {
          let fileUrl = file.split('(')[1]
          fileUrl = fileUrl && fileUrl.substring(0, fileUrl.length - 1)

          let fileName = file.split('[')[1]
          fileName = fileName && fileName.split(']')[0]

          if (fileUrl && fileName) {
            return '<a href="' + fileUrl + '" target="_blank" class="blue-grey darken-1 px-3 py-2" style="display:inline-block; border-radius:3px; color: white; text-decoration:none">' + fileName + '</a>'
          }
          return file
        })
        // URL
        const urlRegex = /(https?:\/\/[^\s]+)/g
        ajustedText = ajustedText.replace(urlRegex, (url) => {
          if (url.search('"') >= 0) return url
          return '<a href="' + url + '" target="_blank">' + url + '</a>'
        })
      }
      return ajustedText || '--Sem conteudo--'
    }
  }
}
</script>
